import { Link } from "react-router-dom";

export function Logo({ light = false, className = "", heightClass = "h-12" }) {
  return (
    <Link to="/" className={`inline-flex items-center group ${className}`} data-testid="brand-logo">
      <img
        src={light ? "/elite-logo-light.png" : "/elite-logo-dark.png"}
        alt="Elite"
        className={`${heightClass} w-auto transition-transform duration-300 group-hover:scale-105`}
      />
    </Link>
  );
}
